import { EntityInfo, EntityInfoType } from "@app/entity/model/entityinfo";
import { FormatPhonePipe } from "@app/shared/resources/phone-formatter.pipe";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { EntityInfoState, initialEntityInfoState } from "../entityinfo.state";

const selectState = createFeatureSelector<EntityInfoState>("entityinfos");

export const selectEntityInfoTypes = createSelector(selectState, (state: EntityInfoState = initialEntityInfoState) =>
    state.entityinfoTypes ? state.entityinfoTypes.result : {}
);

export const selectEntityInfoTypesState = createSelector(
    selectState,
    (state: EntityInfoState = initialEntityInfoState) => state.entityinfoTypes
);

export const selectEntityInfoObjectById = (id: number) =>
    createSelector(selectState, (state = initialEntityInfoState) => {
        let info: EntityInfo;
        const entityInfos = state.entityinfos.result;
        Object.keys(entityInfos).forEach(key => {
            if (entityInfos[key].id === id) {
                info = entityInfos[key];
            }
        });
        return info;
    });

export const getEntityInfoCallState = createSelector(
    selectState,
    (state: EntityInfoState = initialEntityInfoState) => state.entityinfos.callState
);

export const formatPhone = (phone: string) => {
    if (phone) {
        return new FormatPhonePipe().transform(phone, "x (xxx) xxx-xxxx");
    }
    return null;
};

export const formatRate = (rate: number, currency: string) => {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency || "USD",
        minimumFractionDigits: 2,
    });

    if (!Number.isNaN(+rate)) {
        return formatter.format(rate);
    }
    return null;
};

export const getInfoType = (entityInfoTypesState, entityInfo: EntityInfo): EntityInfoType => {
    if (entityInfoTypesState?.result) {
        return entityInfoTypesState.result[entityInfo.entityInfoTypeId] || null;
    }
    return null;
};

export const getEntityInfos = createSelector(selectState, (state: EntityInfoState = initialEntityInfoState) => state.entityinfos.result);

export const getEntityInfo = (id: number) =>
    createSelector(selectState, (state: EntityInfoState = initialEntityInfoState) =>
        state.entityinfos.result ? state.entityinfos.result[id] : null
    );

export const getEntityInfoList = createSelector(selectState, (state: EntityInfoState = initialEntityInfoState) => {
    const infoList = [];
    const entityInfos = state.entityinfos.result;
    for (const info in entityInfos) {
        if (entityInfos[info]) {
            const entityInfo = entityInfos[info];
            infoList.push({
                ...entityInfo.data,
                phone: formatPhone(entityInfo.data.phone),
                id: entityInfo.id,
                rate: formatRate(entityInfo.data.rate, entityInfo.data.currency),
            });
        }
    }
    return infoList;
});

export const getEntityInfoListByType = (infoType?: string) =>
    createSelector(selectState, (state: EntityInfoState = initialEntityInfoState) => {
        const infoList = [];
        const entityInfos = state.entityinfos.result;
        for (const info in entityInfos) {
            if (entityInfos[info]) {
                const entityInfo = entityInfos[info];
                const entityInfoType = getInfoType(state.entityinfoTypes, entityInfo);
                if (entityInfo && !!infoType && entityInfoType?.key === infoType) {
                    infoList.push({
                        ...entityInfo.data,
                        phone: formatPhone(entityInfo.data.phone),
                        id: entityInfo.id,
                        rate: formatRate(entityInfo.data.rate, entityInfo.data.currency),
                    });
                }
            }
        }
        return infoList;
    });

export const getEntityInfoListByTypeId = (infoTypeId: number) =>
    createSelector(selectState, (state: EntityInfoState = initialEntityInfoState) => {
        const infoList = [];
        const entityInfos = state.entityinfos.result;
        for (const info in entityInfos) {
            if (entityInfos[info]) {
                const entityInfo = entityInfos[info];
                if (entityInfo && entityInfo.entityInfoTypeId === infoTypeId) {
                    infoList.push({
                        ...entityInfo.data,
                        phone: formatPhone(entityInfo.data.phone),
                        id: entityInfo.id,
                        rate: formatRate(entityInfo.data.rate, entityInfo.data.currency),
                    });
                }
            }
        }
        return infoList;
    });
